export const TRACKING_ZONES = {
  SEND_MESSAGE_FLOW: 'customer-conversation-send-message-flow',
}

export const FORM_NAME = 'messageform'
